module.exports = __webpack_public_path__ + "static/media/trust-performance.321801b2.png";